import React from 'react';
import PropTypes from 'prop-types';
import CustomIcon from '../CustomIcon';

function defaultClick() {}

export const HeaderReveal = ({ title = '', onCloseOnClick = defaultClick }) => {
  return (
    <div className="header">
      <span className="close-btn" onClick={onCloseOnClick}>
        <CustomIcon name="close-button" size={24} />
      </span>
      <span className="title">{title} </span>
    </div>
  );
};

HeaderReveal.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseOnClick: PropTypes.func.isRequired
};

export default HeaderReveal;
